// extracted by mini-css-extract-plugin
export default {"wrapper":"_404_wrapper__SiGiw","content":"_404_content__0NEDe","error":"_404_error__aGjyu","title":"_404_title__ONLue","desc":"_404_desc__EtazI","button":"_404_button__Ewzex"};